import { FC } from "react";
import ListingFilterBadgeListComponent from "../../../../../../../common/components/listing/filter/badge-list/listing-filter-badge-list.component";
import BillingsCargoOrderListingFilter from "../../types/billings-cargo-order-listing-filter";
import billingsCargoOrderListingFiltersBadgeListHelper from "./billings-cargo-order-listing-filters-badge-list.helper";

type BillingsCargoOrderListingFiltersListProps = {
  filters: BillingsCargoOrderListingFilter[];
  onDeleteFilterClick: (filterIndex: number) => void;
  onDeleteAllFiltersButtonClick: () => void;
};

const BillingsCargoOrderListingFiltersBadgeListComponent: FC<
  BillingsCargoOrderListingFiltersListProps
> = (props) => {
  const badges = billingsCargoOrderListingFiltersBadgeListHelper.getBadges(
    props.filters
  );

  return (
    <ListingFilterBadgeListComponent
      badges={badges}
      onDeleteAll={props.onDeleteAllFiltersButtonClick}
      onDelete={props.onDeleteFilterClick}
    />
  );
};

export default BillingsCargoOrderListingFiltersBadgeListComponent;
